import { render } from "./smsIntegration.vue?vue&type=template&id=2578b974"
import script from "./smsIntegration.vue?vue&type=script&lang=js"
export * from "./smsIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__